// for game webview client jsapi
export default defineNuxtPlugin(() => {
  window.promises = window.promises || {}
  window.nativePromiseThen = (promiseId: string, data: any, error: any) => {
    if (error) {
      window.promises[promiseId].reject(data)
    } else {
      window.promises[promiseId].resolve(data)
    }
    delete window.promises[promiseId]
  }
})
